// Year of publication, rights holder (℗/©) and label of a track — the same
// three fields as the web app's studio. All optional.

const TOP_YEAR = new Date().getFullYear() + 1;
const YEARS = Array.from({ length: TOP_YEAR - 1949 }, (_, i) => String(TOP_YEAR - i));

export const EMPTY_RIGHTS = { copyrightYear: '', copyrightHolder: '', label: '' };

export const hasRights = (r) => !!(r && (r.copyrightYear || r.copyrightHolder.trim() || r.label.trim()));

/** Appends the fields insertMusic.php takes to a FormData. */
export function appendRights(fd, r) {
    fd.append('copyright_year', r.copyrightYear || '');
    fd.append('copyright_holder', (r.copyrightHolder || '').trim());
    fd.append('label', (r.label || '').trim());
}

const inputCls = 'block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus:border-amber-500 focus:ring-amber-500';

export default function RightsInputs({ value, onChange, disabled, holderPlaceholder, labelPlaceholder, small }) {
    const labelCls = `mb-1 block font-medium text-gray-700 ${small ? 'text-xs' : 'text-sm'}`;
    return (
        <div>
            <p className="mb-2 text-xs text-gray-500">
                <span className="font-medium text-gray-700">Direitos de autor</span> · ano de publicação da música, titular e selo. Opcional.
            </p>
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-[120px_1fr_1fr]">
                <label className="block">
                    <span className={labelCls}>Ano (℗)</span>
                    <select className={inputCls} value={value.copyrightYear} disabled={disabled}
                        onChange={(e) => onChange({ copyrightYear: e.target.value })}>
                        <option value="">—</option>
                        {YEARS.map((y) => <option key={y} value={y}>{y}</option>)}
                    </select>
                </label>
                <label className="block">
                    <span className={labelCls}>Titular dos direitos</span>
                    <input className={inputCls} value={value.copyrightHolder} maxLength={255} disabled={disabled}
                        placeholder={holderPlaceholder ? `Ex.: ${holderPlaceholder}` : 'Artista ou editora'}
                        onChange={(e) => onChange({ copyrightHolder: e.target.value })} />
                </label>
                <label className="block">
                    <span className={labelCls}>Selo</span>
                    <input className={inputCls} value={value.label} maxLength={255} disabled={disabled}
                        placeholder={labelPlaceholder ? `Ex.: ${labelPlaceholder}` : 'Editora responsável pelo envio'}
                        onChange={(e) => onChange({ label: e.target.value })} />
                </label>
            </div>
        </div>
    );
}
